import { render, staticRenderFns } from "./FrequencySettingsMonthly.vue?vue&type=template&id=5ba2a71e"
import script from "./FrequencySettingsMonthly.vue?vue&type=script&lang=ts"
export * from "./FrequencySettingsMonthly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba2a71e')) {
      api.createRecord('5ba2a71e', component.options)
    } else {
      api.reload('5ba2a71e', component.options)
    }
    module.hot.accept("./FrequencySettingsMonthly.vue?vue&type=template&id=5ba2a71e", function () {
      api.rerender('5ba2a71e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency/FrequencySettingsMonthly.vue"
export default component.exports